// @flow

// Action Types
const actionPrefix: string = '@@datatable/assets/'
export const SELECT_RECORDS = `${actionPrefix}SELECT_RECORDS`
export const UPDATE_FILTER = `${actionPrefix}UPDATE_FILTER`

// Datatable
export const DATATABLE_NAME = 'Assets'

// Record attrs
export const ATTR_ASSET_ID = 'id'
export const ATTR_LABEL = 'label'
export const ATTR_CATEGORY = 'category'
export const ATTR_SHAPE = 'shape'
export const ATTR_AREA = 'area'
export const ATTR_MAP_VIEW = 'mapView'
export const ATTR_PARENT_ID = 'parentId'
export const ATTR_HAS_ACTIVE_MAP_VIEW = 'hasActiveMapView'
export const ATTR_GROUP_BY_BOUNDARY_TYPE = 'groupByBoundaryType'
